<template>
  <div class="page-container">
    <div class="ai-panel"><div class="ai-panel-title">{{ config.icon }} {{ config.title }} · AI 增强</div>{{ config.ai }}</div>
    <div v-if="moduleName === 'visit'" class="visit-filters business-list-toolbar">
      <el-select v-model="query.region_name" clearable filterable placeholder="省区" :loading="visitFiltersLoading" @change="visitRegionChanged"><el-option v-for="name in visitRegions" :key="name" :label="name" :value="name" /></el-select>
      <el-select v-model="query.hospital_name" clearable filterable placeholder="医院" :loading="visitFiltersLoading" @change="visitHospitalChanged"><el-option v-for="name in visitHospitals" :key="name" :label="name" :value="name" /></el-select>
      <el-select v-model="query.department_name" clearable filterable placeholder="科室" :loading="visitFiltersLoading" @change="visitDepartmentChanged"><el-option v-for="name in visitDepartments" :key="name" :label="name" :value="name" /></el-select>
      <el-select v-model="query.doctor_name" clearable filterable placeholder="医生" :loading="visitFiltersLoading"><el-option v-for="name in visitDoctors" :key="name" :label="name" :value="name" /></el-select>
    </div>
    <div class="toolbar business-list-toolbar">
      <el-input v-model="query.keyword" clearable :placeholder="keywordPlaceholder" prefix-icon="el-icon-search" style="width:280px" @keyup.enter.native="moduleName === 'visit' ? search() : load()" />
      <el-input v-if="moduleName === 'visit'" v-model="query.participant_name" clearable placeholder="参与代表名称" prefix-icon="el-icon-user" style="width:200px" @keyup.enter.native="search" />
      <el-select v-if="config.statusFilter !== false" v-model="query.status" clearable placeholder="全部状态" :style="{width:moduleName === 'visit' ? '180px' : '150px'}" @change="moduleName === 'visit' ? search() : load()">
        <el-option v-for="status in filterStatuses" :key="status.value" :label="status.label" :value="status.value" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="moduleName === 'visit' ? search() : load()">查询</el-button>
      <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      <div style="flex:1"></div>
      <el-button v-if="!config.readonly && canWrite" type="primary" icon="el-icon-plus" @click="openCreate">新增</el-button>
      <el-button v-if="moduleName === 'audit'" icon="el-icon-download" @click="exportCsv">导出当前页</el-button>
    </div>
    <div class="panel table-panel business-list-panel">
      <el-table v-loading="loading" :data="displayItems" class="business-list-table" stripe>
        <el-table-column label="序号" width="68" align="center"><template slot-scope="{$index}"><span class="list-index">{{ (query.page_index - 1) * query.page_size + $index + 1 }}</span></template></el-table-column>
        <el-table-column v-for="column in config.columns" :key="column[0]" :label="column[1]" :min-width="widthOf(column[0])" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span v-if="isStatus(column[0])" :class="statusClass(value(row,column[0]))">{{ displayValue(row,column[0]) }}</span>
            <span v-else>{{ displayValue(row,column[0]) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" :width="moduleName === 'meeting' || moduleName === 'visit' ? 92 : 176">
          <template slot-scope="{row}">
            <el-button type="text" @click="showDetail(row)">详情</el-button>
            <el-button v-if="moduleName !== 'meeting' && !config.readonly && canWrite && row.fields.status !== 'COMPLETED'" type="text" @click="openEdit(row)">编辑</el-button>
            <el-dropdown v-if="moduleName !== 'meeting' && !config.readonly && canWrite && hasStatus(row)" @command="status => changeStatus(row,status)">
              <el-button type="text">状态⌄</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="status in statuses" :key="status" :command="status">{{ status }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination"><el-pagination background layout="total, sizes, prev, pager, next" :total="total" :current-page.sync="query.page_index" :page-size.sync="query.page_size" :page-sizes="[10,20,50,100]" @current-change="load" @size-change="load" /></div>
    </div>

    <el-dialog :title="editingId ? '编辑' + config.title : '新增' + config.title" :visible.sync="formVisible" width="620px" destroy-on-close>
      <el-form ref="editForm" :model="form" label-position="top">
        <el-row :gutter="18">
          <el-col v-for="field in config.editable || []" :key="field[0]" :span="longField(field[0]) ? 24 : 12">
            <el-form-item :label="field[1]" :prop="field[0]">
              <el-input v-if="longField(field[0])" v-model="form[field[0]]" type="textarea" :rows="3" />
              <el-select v-else-if="field[0] === 'status'" v-model="form[field[0]]" style="width:100%">
                <el-option v-for="status in statuses" :key="status" :label="status" :value="status" />
              </el-select>
              <el-input v-else v-model="form[field[0]]" :disabled="disabledField(field[0])" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer"><el-button @click="formVisible=false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>

    <el-drawer :title="drawerTitle" :visible.sync="detailVisible" size="56%" custom-class="business-detail-drawer">
      <div v-loading="detailLoading" class="drawer">
      <template v-if="detail">
        <template v-if="moduleName === 'meeting' && meetingDetail">
          <div class="meeting-detail-head">
            <div class="meeting-eyebrow">科室会记录</div>
            <h2>{{ meetingDetail.subject || '未命名科室会' }}</h2>
            <div class="meeting-meta"><span>🕒 {{ meetingDetail.meeting_time || '时间未填写' }}</span><span>📍 {{ meetingDetail.location || '地点未填写' }}</span></div>
          </div>
          <div class="detail-section-title"><span>会议信息</span><small>经人工确认后的记录</small></div>
          <el-descriptions :column="2" border class="meeting-descriptions">
            <el-descriptions-item label="讲者">{{ meetingDetail.speaker_name || '未填写' }}</el-descriptions-item>
            <el-descriptions-item label="参加人">{{ meetingDetail.participant_names || '未登记' }}</el-descriptions-item>
            <el-descriptions-item label="医院">{{ meetingDetail.hospital_name || '未关联' }}</el-descriptions-item>
            <el-descriptions-item label="科室">{{ meetingDetail.department_name || '未关联' }}</el-descriptions-item>
            <el-descriptions-item label="记录提交人">{{ meetingDetail.submitter_name || '—' }}</el-descriptions-item>
            <el-descriptions-item label="提交时间">{{ meetingDetail.created_at || '—' }}</el-descriptions-item>
          </el-descriptions>
          <div class="detail-section-title"><span>AI 会议纪要</span><small>会议核心内容</small></div>
          <div class="meeting-text-card highlight">{{ meetingDetail.minutes_text || '暂无会议纪要' }}</div>
          <div class="detail-section-title"><span>录音识别原文</span><small>AI 转写结果</small></div>
          <div class="meeting-text-card transcript">{{ meetingDetail.ai_transcript || '暂无识别原文' }}</div>
          <div class="detail-section-title"><span>录音与追溯信息</span><small>用于核对 AI 处理来源</small></div>
          <el-descriptions :column="1" border class="meeting-descriptions trace-info">
            <el-descriptions-item label="录音文件">{{ meetingDetail.audio_file_name || '未关联' }}</el-descriptions-item>
            <el-descriptions-item label="AI 请求编号">{{ meetingDetail.ai_request_id || '—' }}</el-descriptions-item>
            <el-descriptions-item label="数据版本">{{ meetingDetail.ai_schema_version || '—' }}</el-descriptions-item>
          </el-descriptions>
        </template>
        <template v-else-if="moduleName === 'visit'"><visit-detail v-if="visitDetail" :visit="visitDetail" /></template>
        <el-descriptions v-else :column="1" border>
          <el-descriptions-item v-for="(value,key) in displayedDetailFields" :key="key" :label="fieldLabel(key)">{{ value || '—' }}</el-descriptions-item>
        </el-descriptions>
      </template>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import configs from '../config/modules'
import { moduleApi, visitApi } from '../services/api'
import VisitDetail from './VisitDetail.vue'
import { visitStatusLabel, complianceStatusLabel, visitListDisplayFields } from '../utils/visit-display'

export default {
  components: { VisitDetail },
  data: () => ({
    loading: false, saving: false, detailLoading: false, items: [], total: 0,
    visitFiltersLoading: false, visitFilterPaths: [],
    query: { keyword: '', participant_name: '', region_name: '', hospital_name: '', department_name: '', doctor_name: '', status: '', page_index: 1, page_size: 20 },
    formVisible: false, detailVisible: false, editingId: '', form: {}, detail: null, visitDetail: null,
    statuses: ['DRAFT','ACTIVE','PUBLISHED','PENDING','PROCESSING','WAIT_CONFIRM','COMPLETED','CLOSED']
  }),
  computed: {
    visitRegions () { return this.visitOptions('region_name', []) },
    visitHospitals () { return this.visitOptions('hospital_name', ['region_name']) },
    visitDepartments () { return this.visitOptions('department_name', ['region_name', 'hospital_name']) },
    visitDoctors () { return this.visitOptions('doctor_name', ['region_name', 'hospital_name', 'department_name']) },
    displayItems () {
      return this.moduleName === 'visit'
        ? this.items.map(row => Object.assign({}, row, { fields: visitListDisplayFields(row.fields || {}) }))
        : this.items
    },
    moduleName () { return this.$route.meta.module },
    canWrite () { return this.$store.getters.can(this.moduleName + '.write') },
    config () { return configs[this.moduleName] || { title: this.$route.meta.title, icon: '📁', ai: '', columns: [], readonly: true } },
    keywordPlaceholder () { return this.moduleName === 'meeting' ? '搜索会议主题' : '输入关键词搜索' },
    drawerTitle () { return this.moduleName === 'meeting' ? '科室会详情' : this.config.title + '详情' },
    meetingDetail () { return this.moduleName === 'meeting' && this.detail ? this.detail.fields || {} : null },
    filterStatuses () {
      return this.moduleName === 'visit'
        ? ['COMPLETED', 'DRAFT', 'AI_PROCESSING', 'NEED_SUPPLEMENT', 'NEED_MODIFY', 'WAIT_CONFIRM'].map(value => ({ value, label: visitStatusLabel(value) }))
        : this.statuses.map(value => ({ value, label: value }))
    },
    displayedDetailFields () {
      const fields=(this.detail && this.detail.fields) || {}
      if (this.moduleName !== 'feedback') return fields
      const hidden=['user_id','doctor_id','product_id','source_type','source_id']
      return Object.keys(fields).reduce((result,key) => { if (!hidden.includes(key)) result[key]=fields[key]; return result },{})
    }
  },
  watch: {
    '$route.meta.module': { immediate: true, handler () {
      this.query = { keyword:'',participant_name:'',region_name:'',hospital_name:'',department_name:'',doctor_name:'',status:'',page_index:1,page_size:20 }
      this.visitFilterPaths = []
      if (this.moduleName === 'visit') this.loadVisitFilterOptions()
      this.load()
    } }
  },
  methods: {
    async loadVisitFilterOptions () {
      this.visitFiltersLoading = true
      try {
        const paths = await visitApi.filterOptions()
        if (this.moduleName === 'visit') this.visitFilterPaths = paths || []
      } catch (error) { this.$message.error(error.message) } finally { this.visitFiltersLoading = false }
    },
    visitOptions (field, parents) {
      const paths = this.visitFilterPaths.filter(path => parents.every(parent => !this.query[parent] || path[parent] === this.query[parent]))
      return Array.from(new Set(paths.map(path => path[field]).filter(name => name && name.trim())))
    },
    visitRegionChanged () { this.query.hospital_name=''; this.query.department_name=''; this.query.doctor_name='' },
    visitHospitalChanged () { this.query.department_name=''; this.query.doctor_name='' },
    visitDepartmentChanged () { this.query.doctor_name='' },
    async load () {
      this.loading = true
      try {
        const result = await moduleApi.list(Object.assign({ module: this.moduleName }, this.query))
        this.items = result.items || []; this.total = result.total || 0
      } catch (e) { this.$message.error(e.message) } finally { this.loading = false }
    },
    search () { this.query.page_index=1; this.load() },
    reset () {
      this.query.keyword=''; this.query.participant_name=''; this.query.status=''; this.query.page_index=1
      this.query.region_name=''; this.query.hospital_name=''; this.query.department_name=''; this.query.doctor_name=''
      this.load()
    },
    value (row, field) { return row.fields ? row.fields[field] : '' },
    displayValue (row, field) {
      const current=this.value(row,field)
      if (field === 'has_feedback_issue') return current === '1' || current === true ? '是' : '否'
      if (this.moduleName === 'visit' && field === 'status') return visitStatusLabel(current)
      if (this.moduleName === 'visit' && field === 'compliance_status') return complianceStatusLabel(current)
      if (this.moduleName === 'visit' && field === 'gps_status') return current === 'PASS' ? '通过' : '待获取'
      return current || '—'
    },
    isStatus (field) { return /status|level|success/.test(field) },
    statusClass (status) {
      if (/PASS|ACTIVE|VALID|PUBLISHED|COMPLETED|CLOSED|1/.test(status || '')) return 'tag-pass'
      if (/FAIL|RED|OVERDUE|REJECT/.test(status || '')) return 'tag-fail'
      return 'tag-wait'
    },
    hasStatus (row) { return Object.prototype.hasOwnProperty.call(row.fields || {}, 'status') },
    widthOf (field) {
      if (this.moduleName === 'visit') {
        if (field === 'visit_no') return 200
        if (field === 'visit_time') return 190
        if (field === 'hospital_name') return 220
        if (field === 'department_name') return 150
        if (field === 'doctor_name') return 130
      }
      return field === 'participants' ? 140 : (/content|summary|analysis|reason|draft|participant/.test(field) ? 220 : 110)
    },
    longField (field) { return /content|summary|analysis|reaction|contraindication|minutes|draft|comment/.test(field) },
    disabledField (field) { return this.moduleName === 'feedback' && this.form.source_type === 'VISIT' && /^(source_type|source_id)$/.test(field) },
    openCreate () { this.editingId=''; this.form={ status:'DRAFT' }; this.formVisible=true },
    openEdit (row) { this.editingId=row.sjid; this.form=Object.assign({},row.fields); this.formVisible=true },
    async save () {
      this.saving = true
      try {
        await moduleApi.save({ module:this.moduleName,sjid:this.editingId,fields:this.form })
        this.$message.success('保存成功'); this.formVisible=false; this.load()
      } catch (e) { this.$message.error(e.message) } finally { this.saving=false }
    },
    async changeStatus (row, status) {
      try { await moduleApi.changeStatus({ module:this.moduleName,sjid:row.sjid,status,remark:'PC 管理后台状态变更' }); this.$message.success('状态已更新'); this.load() }
      catch (e) { this.$message.error(e.message) }
    },
    async showDetail (row) {
      this.detailVisible=true; this.detail=row; this.visitDetail=null; this.detailLoading=true
      try {
        if (this.moduleName === 'visit') this.visitDetail = await visitApi.detail(row.sjid)
        else this.detail = await moduleApi.get(this.moduleName,row.sjid)
      } catch (e) { this.detailVisible=false; this.$message.error(e.message) } finally { this.detailLoading=false }
    },
    fieldLabel (key) {
      const match=(this.config.columns || []).concat(this.config.editable || []).find(item=>item[0]===key)
      return match ? match[1] : key
    },
    exportCsv () {
      const heads=this.config.columns.map(item=>item[1]); const keys=this.config.columns.map(item=>item[0])
      const escape=value=>'"'+String(value == null ? '' : value).replace(/"/g,'""')+'"'
      const lines=[heads.map(escape).join(',')].concat(this.items.map(row=>keys.map(key=>escape(this.value(row,key))).join(',')))
      const blob=new Blob(['\ufeff'+lines.join('\n')],{type:'text/csv;charset=utf-8'})
      const link=document.createElement('a'); link.href=URL.createObjectURL(blob); link.download=this.config.title+'.csv'; link.click(); URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style scoped>
.visit-filters { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:10px; margin-bottom:12px; }
.visit-filters .el-select { width:100%; min-width:0; }
.visit-filters + .toolbar { flex-wrap:wrap; }
@media(max-width:1000px) { .visit-filters { grid-template-columns:repeat(2,minmax(0,1fr)); } }
.table-panel{overflow:hidden}.pagination{padding:16px;text-align:right}.drawer{padding:0 28px 40px}.visit-head{display:flex;justify-content:space-between;align-items:center;padding:0 0 20px}.visit-head small,.visit-head strong{display:block}.visit-head strong{font-size:20px;margin-top:5px}.drawer h3{margin-top:25px}.compliance-round{margin-bottom:20px}.round-title{font-weight:700;margin:10px 0}.round-title .muted{font-size:12px;font-weight:400;margin-left:7px}.meeting-detail-head{padding:22px 24px;margin-bottom:22px;border:1px solid #e5dcf7;border-radius:12px;background:linear-gradient(120deg,#f7f2ff,#fff)}.meeting-eyebrow{color:#7850ca;font-size:12px;font-weight:700;letter-spacing:2px}.meeting-detail-head h2{margin:8px 0 13px;color:#263548;font-size:24px}.meeting-meta{display:flex;gap:24px;flex-wrap:wrap;color:#6f7d90;font-size:13px}.detail-section-title{display:flex;align-items:baseline;justify-content:space-between;margin:24px 0 11px;color:#344653}.detail-section-title span{font-size:17px;font-weight:700}.detail-section-title small{color:#8b96a5}.meeting-text-card{padding:18px 20px;border:1px solid #e3e8ef;border-radius:10px;background:#fbfcfe;color:#344255;line-height:1.8;white-space:pre-wrap;word-break:break-word}.meeting-text-card.highlight{border-color:#dfd2f8;background:#faf7ff}.meeting-text-card.transcript{max-height:300px;overflow:auto}.meeting-descriptions{border-radius:8px;overflow:hidden}.trace-info{margin-bottom:20px}
</style>
